"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneStatus = void 0;
var ZoneStatus;
(function (ZoneStatus) {
    ZoneStatus["VISIBLE"] = "VISIBLE";
    ZoneStatus["HIDDEN"] = "HIDDEN";
})(ZoneStatus = exports.ZoneStatus || (exports.ZoneStatus = {}));
